import removeMd from 'remove-markdown'

export function convertMarkdownToText(markdown: string) {
  return removeMd(markdown)
}
